const styles = theme => ({
    root: {
        background: theme.bodyBackground ? theme.bodyBackground : '#f9f9f9',
        minHeight: '100vh'
    },
    container: {
        maxWidth: 960,
        margin: 'auto',
        [theme.breakpoints.up(600)]: {
            paddingLeft: 16,
            paddingRight: 16
        },
    },
    elementContainer: {
        width: '100%',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(10),
        [theme.breakpoints.up(980)]: {
            marginTop: -theme.spacing(1) * 2
        }
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        background: theme.paper ? theme.paper.background : '#f9f9f9',
        minHeight: '83vh',
        [theme.breakpoints.up(600)]: {
            minHeight: '813px'
        },
        fontFamily: theme.fontFamily + '!important',
        overflow: 'hidden'
    },
    paper: {
        padding: theme.spacing(2),
        paddingBottom: theme.spacing(1) + 'px!important',
        [theme.breakpoints.up(600)]: {
            padding: theme.spacing(4),
            paddingTop: theme.spacing(4) + 'px!important',
            paddingBottom: theme.spacing(1) + 'px!important'
        },
        boxShadow: theme.paper ? theme.paper.boxShadow : null,
        paddingTop: theme.paper ? theme.paper.paddingTop : theme.spacing(3) + 'px!important',
        borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important'
    },
    imageWrapper: {
        display: 'block',
        textAlign: 'center',
        padding: theme.spacing(1),
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.up(980)]: {
            paddingTop: theme.spacing(8)
        },
        [theme.breakpoints.up(1400)]: {
            display: 'none'
        }
    },
    image: {
        maxWidth: '100%'
    },
    elementItem: {
        paddingBottom: 1
    },
    header: {
        padding: `0 ${theme.spacing(1.5)}px`,
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(1.5),
        [theme.breakpoints.up(980)]: {
            marginBottom: theme.spacing(4),
            marginTop: theme.spacing(2)
        }
    },
    headerWithOffers: {
        marginBottom: theme.spacing(4),
        [theme.breakpoints.up(980)]: {
            marginBottom: theme.spacing(7)
        },
        [theme.breakpoints.down(600)]: {
            marginBottom: theme.spacing(2.5)
        }
    },
    title: {
        maxWidth: 680,
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center!important',
        fontSize: '2rem!important',
        marginTop: theme.spacing(0) + 'px!important',
        marginBottom: theme.spacing(1),
        [theme.breakpoints.up(980)]: {
            marginTop: theme.spacing(4) + 'px!important'
        },
        '& .product-name': {
            color: theme.palette.primaryColor,
            fontSize: '105%',
            margin: '0 2px',
            fontWeight: 800
        },
        [theme.breakpoints.down(600)]: {
            fontSize: '1.3rem!important'
        }
    },
    description: {
        maxWidth: 680,
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center!important',
        fontSize: '1.2rem!important',
        color: 'rgba(0, 0, 0, 0.54)!important',
        [theme.breakpoints.down(600)]: {
            fontSize: '1rem!important'
        }
    },
    buttonWrapper: {
        textAlign: 'center',
        display: 'block'
    },
    button: {
        color: '#ffffff',
        //width: '100%!important',
        boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)!important',
        //maxWidth: 150,
        minWidth: '140px!important',
        lineHeight: '15px',
        padding: '0 20px',
        marginBottom: 40,
        borderRadius: theme.forwardButton ? theme.forwardButton.borderRadius + 'px!important' : 32
    },
    rightIcon: {
        marginLeft: 16
    },
    headerImageWrapper: {
        [theme.breakpoints.up(980)]: {
            paddingTop: theme.spacing(2)
        },
        display: 'flex'
    },
    headerIcon: {
        fontSize: '5rem',
        margin: 'auto',
        color: '#f3ca1b'
    }
})

export { styles }
